import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-street-suggestion-item',
  template: `
    <span class="ellipsis" [innerHtml]="html"></span>
  `,
  styleUrls: ['./street-suggestion-item.component.scss'],
})
export class StreetSuggestionItemComponent implements OnChanges {
  @Input()
  value?: google.maps.places.AutocompletePrediction;

  html?: string;

  ngOnChanges(): void {
    if (!this.value) {
      return;
    }
    const prediction = this.value;
    let lengthOffset = 0;
    let content = '';
    prediction.matched_substrings.forEach(s => {
      const start = s.offset + lengthOffset;
      const end = s.offset + s.length + lengthOffset;
      const match = prediction.description.slice(start, end);
      content = this.replaceBetween(prediction.description, start, end, `<b>${match}</b>`);
      lengthOffset += 7;
    });
    this.html = content
      .split(',')
      .map((s, i) => (i === 0 ? `<span class="main">${s}</span>` : s))
      .join(',');
  }

  private replaceBetween(value: string, start: number, end: number, what: string): string {
    return value.substring(0, start) + what + value.substring(end);
  }
}
